import {
	createRouter,
	createWebHistory,
	createWebHashHistory,
} from "vue-router";
import { isEmptyObject } from "@/utils/index";
import { getToken } from "@/utils/auth";
import store from "@/store";
const Layout = () => import("@/layout/index.vue");
const routes = [
	{
		path: "/",
		name: "home",
		component: Layout,
		redirect: "/square",
		children: [
			{
				path: "/square",
				name: "square",
				component: () => import("@/views/square"),
			},
			{
				path: "/search",
				name: "search",
				component: () => import("@/views/search"),
			},
			{
				path: "/mine",
				name: "mine",
				component: () => import("@/views/user"),
			},
			{
				path: "/circle",
				name: "circle",
				component: () => import("@/views/circle"),
			},
			{
				path: "/message",
				name: "message",
				component: () => import("@/views/message"),
			},
			{
				path: "/mine/customer",
				name: "客服中心",
				component: () => import("@/views/user/serviceCenter.vue"),
			},
			{
				path: "/serviceCenter2Back",
				name: "serviceCenter2Back",
				component: () => import("@/views/user/serviceCenter2Back.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("@/views/login"),
	},
	{
		path: "/changeUser",
		name: "changeUser",
		component: () => import("@/views/login"),
	},
	{
		path: "/circle/add",
		name: "创建圈子",
		component: () => import("@/views/circle/createForm.vue"),
	},
	{
		path: "/circle/edit-info",
		name: "修改圈子信息",
		component: () => import("@/views/circle/editCircleInfo.vue"),
	},
	{
		path: "/circle/edit-price",
		name: "修改圈子价格及微信",
		component: () => import("@/views/circle/editCirclePrice.vue"),
	},
	{
		path: "/mine/home",
		name: "my-home",
		component: () => import("@/views/user/myHomePage.vue"),
	},
	{
		path: "/circle/circle-detail",
		name: "circle-detail",
		component: () => import("@/views/circle/circleHome.vue"),
	},
	{
		path: "/relation",
		name: "relation",
		component: () => import("@/views/user/relation.vue"),
	},
	{
		path: "/circle/detail/:userId",
		name: "circle-detail",
		component: () => import("@/views/circle/circleHome.vue"),
	},
	{
		path: "/movement/post/:cost",
		name: "post-movement",
		component: () => import("@/views/circle/post.vue"),
	},
	{
		path: "/post/:id",
		name: "edit-post",
		component: () => import("@/views/circle/post.vue"),
		meta: {
			isEdit: true,
		},
	},
	{
		path: "/post/detail/:id",
		name: "post-detail",
		component: () => import("@/views/circle/postDetail.vue"),
	},
	{
		path: "/share/:id",
		name: "share",
		component: () => import("@/views/share/index.vue"),
		meta: {
			needNotLogin: true,
		},
	},
	{
		path: "/mine/account",
		name: "my account",
		component: () => import("@/views/user/account.vue"),
	},
	{
		path: "/mine/account-detail",
		name: "my account detail",
		component: () => import("@/views/user/accountDetail.vue"),
	},
	{
		path: "/mine/refund",
		name: "退款列表",
		component: () => import("@/views/user/refund.vue"),
	},
	{
		path: "/user/:id",
		name: "用户首页",
		component: () => import("@/views/user/userHomePage.vue"),
		meta: {
			isOther: true,
		},
	},
	{
		path: "/alipay",
		name: "支付宝回跳页面",
		component: () => import("@/views/alipay/index.vue"),
	},
	{
		path: "/download",
		name: "download",
		component: () => import("@/views/download"),
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

router.beforeEach(async (to, from, next) => {
	const publicPages = ["/login"]; // 不需要登录就能访问的页面
	const needNotLogin = publicPages.includes(to.path) || to.meta.needNotLogin; // 是否在登录白名单

	const token = getToken();
	if (getToken()) {
		if (isEmptyObject(store.state.user.userInfo)) {
			await store.dispatch("getUser");
		}
		next();
	} else {
		if (needNotLogin) {
			next();
		} else {
			next({
				path: "/login",
				query: {
					redirect: to.path,
				},
			});
		}
	}
});

export default router;
